/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Floating_Open_Full_ViewInputs */



/**
* | output |
* | --- |
* | "Open full view" |
*
* @param {Spaces_Floating_Open_Full_ViewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_floating_open_full_view = /** @type {((inputs?: Spaces_Floating_Open_Full_ViewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Floating_Open_Full_ViewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollansicht öffnen")
	return /** @type {LocalizedString} */ ("Open full view")
});